// src/sections/ThankYou.jsx
import React from 'react';
import { FaHome, FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/');
  };

  return (
    <section className="flex flex-col items-center justify-center text-center min-h-screen py-24 px-6 font-cormorant bg-white">
      <FaCheckCircle className="text-6xl text-darkred1 mb-6" />
      <h2 className="text-3xl font-bold mb-4">Obrigado!</h2>
      <p className="text-lg text-darkblue2 max-w-md mb-8">
        Esperamos que o eBook seja útil para você! Se precisar de mais informações, estou à disposição.
      </p>
      <button
        onClick={handleGoHome}
        className="inline-flex items-center gap-3 bg-darkred1 hover:bg-darkred2 text-white text-lg font-semibold px-8 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105"
      >
        <FaHome className="text-2xl" />
        Voltar para Home
      </button>
    </section>
  );
};

export default ThankYou;
